import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { RequestFieldFiltersService } from './service/request-field-filters.service';
import { RequestFieldFilterInterface } from 'src/app/util/interfaces/request';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-request-field-filters',
	templateUrl: './request-field-filters.component.html',
	styleUrls: ['./request-field-filters.component.scss'],
})
export class RequestFieldFiltersComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_filtros_disponiveis: 'Available Filters',
		lbl_reiniciar_filtros: 'Restart Filters',
		lbl_geral_salvar: 'Save',
		lbl_salvo_com_sucesso: '',
		lbl_an_errour_occour: '',
		lbl_reiniciado_com_sucesso: '',
		lbl_geral_filtros_visiveis_para_usuario: '',
		lbl_geral_filtros_visiveis_para_analista: '',
		lbl_geral_selecao_filtros_ocultara_campos_correspondentes: 'Filter selection will hide the corresponding fields for these filters',
	};

	icons = {
		faInfoCircle: faInfoCircle,
	};

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private RequestFieldFiltersService: RequestFieldFiltersService,
		private cdr: ChangeDetectorRef
	) {}

	isLoadingLabels = true;
	isLoadingFilters = true;
	isUpdating = false;
	isReseting = false;

	selectedFilterEnduser: string[] = [];
	selectedFilterAnalyst: string[] = [];
	requestFilters: RequestFieldFilterInterface[] = [];

	filterOptionsEnduser: genericFormInterface[] = [
		{
			name: 'hideColumnsForEnduser',
			label: 'lbl_geral_filtros_visiveis_para_usuario',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	filterOptionsAnalyst: genericFormInterface[] = [
		{
			name: 'hideColumnsForAnalyst',
			label: 'lbl_geral_filtros_visiveis_para_analista',
			inputType: 'multi-select',
			values: [],
			outItems: [],
			items: [],
			filterItem: [''],
			filterValues: [''],
			rawValues: [''],
		},
	];

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.RequestFieldFiltersService.getSelectedFilters()
			.subscribe((filters: RequestFieldFilterInterface[]) => {
				if (filters && filters.length > 0) {
					this.selectedFilterEnduser = filters[0].selectedFilterEnduser;
					this.selectedFilterAnalyst = filters[0].selectedFilterAnalyst;
				}
			})
			.add(() => {
				this.generateConfigurationForm();
			});

		this.getAllFilters();
	}

	getAllFilters(): void {
		this.RequestFieldFiltersService.getFilterOptions().subscribe((filters) => {
			this.requestFilters = filters;
			this.isLoadingFilters = false;

			const mappedItems = this.requestFilters.map((item) => ({
				name: item.name,
				label: item.name,
				value: item.id,
				values: [item.id],
			}));

			this.filterOptionsEnduser[0].items = mappedItems;
			this.filterOptionsAnalyst[0].items = mappedItems;

			this.cdr.detectChanges();
			this.generateConfigurationForm();
		});
	}

	generateConfigurationForm(): void {
		let arrayFilterOptionsEnduser = [];
		let arrayFilterOptionsAnalyst = [];

		if (Array.isArray(this.filterOptionsEnduser[0].items)) {
			arrayFilterOptionsEnduser = this.filterOptionsEnduser[0].items;
		}

		if (Array.isArray(this.filterOptionsAnalyst[0].items)) {
			arrayFilterOptionsAnalyst = this.filterOptionsAnalyst[0].items;
		}

		this.filterOptionsEnduser[0].items = [];
		this.filterOptionsAnalyst[0].items = [];

		this.filterOptionsEnduser[0].rawValues = [];
		this.filterOptionsAnalyst[0].rawValues = [];

		for (const availableItems of arrayFilterOptionsEnduser) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.value,
				values: [availableItems.value],
			};

			this.filterOptionsEnduser[0].items.push(newItem);

			if (this.selectedFilterEnduser) {
				for (const item of this.selectedFilterEnduser) {
					if (item === availableItems.value) {
						this.filterOptionsEnduser[0].values.push(newItem);
						this.filterOptionsEnduser[0].rawValues.push(newItem.value);
					}
				}
			}
		}

		for (const availableItems of arrayFilterOptionsAnalyst) {
			const newItem: genericFormInterface['items'][number] = {
				name: availableItems.name,
				label: availableItems.name,
				value: availableItems.value,
				values: [availableItems.value],
			};

			this.filterOptionsAnalyst[0].items.push(newItem);

			if (this.selectedFilterAnalyst) {
				for (const item of this.selectedFilterAnalyst) {
					if (item === availableItems.value) {
						this.filterOptionsAnalyst[0].values.push(newItem);
						this.filterOptionsAnalyst[0].rawValues.push(newItem.value);
					}
				}
			}
		}
	}

	saveFilter(): void {
		if (this.isUpdating || this.isReseting) return;

		this.isUpdating = true;
		const filterItems = {
			selectedFilterEnduser: this.filterOptionsEnduser[0].rawValues,
			selectedFilterAnalyst: this.filterOptionsAnalyst[0].rawValues,
		};

		this.RequestFieldFiltersService.postFilter(JSON.stringify(filterItems)).subscribe(
			() => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.isUpdating = false;
			},
			() => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_an_errour_occour);
			}
		);
	}

	deleteFilter(): void {
		if (this.isUpdating || this.isReseting) return;
		this.isReseting = true;

		this.RequestFieldFiltersService.deleteFilters().subscribe(() => {
			this.NotificationService.setNotificationMessage(this.labels.lbl_reiniciado_com_sucesso);
			this.filterOptionsEnduser[0].values = [];
			this.filterOptionsEnduser[0].rawValues = [];
			this.filterOptionsAnalyst[0].values = [];
			this.filterOptionsAnalyst[0].rawValues = [];
			this.isReseting = false;
		});
	}
}
